export default {
  coupon: {
    selectCoupons: '選擇優惠券',
    tips: '最佳優惠推薦使用<span class="orange-text">{x}張優惠券</span>，共减免<span class="orange-text">{y}</span>',
    couponTips: '已選擇<span class="orange-text">{x}張優惠券</span>，共减免<span class="orange-text">{y}</span>',
    noSelectedTips: '<span class="orange-text">{x}張優惠券</span>可用',
    changeCard: '更換支付卡',
    automaticPay: '授权状态',
    authorized: '已授權',
    unauthorized: '未授權',
    selectedTips: "已選擇<span class='orange-text'>{x}張優惠券</span>，共减免<span class='orange-text'>{y}</span>",
  },
  automaticPay: {
    queryRecords: '關閉查詢記錄',
    actionTime: '操作時間',
    actionType: '操作類型',
    actionResult: '操作結果',
    resultDesc: '結果描述',
    activate: '開通',
    approved: '通過',
    rejected: '駁回',
    underReview: '審核中',
    autoDeductClose: '是否關閉自動扣款？',
    confirmSubmitClose: '請確認是否提交關閉自動扣款的申請。',
    closeNotice: '本次申請為關閉下月學費自動扣費訂閱，已繳費的費用不予退回。',
    closeNotice2: '當申請審核通過後，系統將不再自動扣款。若超過繳費截止時間，系統會為您自動退班。',
    cancelReasonPrompt: '請選擇取消原因：',
    reasonPrompt: '請選擇原因',
    otherReason: '其他',
    closeReasonInput: '請填寫關閉自動扣款的原因。',
    installmentPlan: '分期付款計劃',
    requestSubmitted: '已提交關閉自動扣款的申請。',
    underReviewNotice: '您有審核中的申請，請勿重複提交。',
    viewReviewResult: ['您可以在', '中查看審核結果'],
    autoApproved: '自動審核通過',
    turnOffAutoDebit: '是否關閉自動扣款？',
    paymentInfo: '付款詳情',
    paymentTime: '付款時間',
    paymentStatus: '付款狀態',
    paymentResult: '結果描述',
    paymentApproved: '成功',
    paymentRejected: '失敗',
  },
}
